import React from 'react'
import { Slider } from 'antd'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import styles from './ProjectFormStepSlider.module.scss'
import { lastStepProjectFormSelector, projectFormCompletedStepsSelector } from 'src/features'

const ProjectFormStepSlider: React.FC = () => {
  const { t } = useTranslation()
  const currentValue = useAppSelector(projectFormCompletedStepsSelector)
  const lastStep = useAppSelector(lastStepProjectFormSelector)

  const sliderProps = {
    min: 0,
    max: lastStep,
    value: currentValue,
    disabled: true,
    step: 1
  }

  return (
    <div className={styles.content}>
      <div className={styles.titleContent}>
        <CustomTitle label={t('Projects.ProjectCompleted')} className={styles.title}/>
        <CustomTitle
          label={`${currentValue}/${lastStep}`}
          style={{ color: '#1C64F2' }}
        />
      </div>
      <Slider {...sliderProps}/>
    </div>
  )
}

export default ProjectFormStepSlider
